module.exports = __webpack_public_path__ + "i18n/ko.bbe46216a6eb4b91916e8b1985431840.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1858
// module chunks = 0